// A song counts as having lyrics only if there is something other than
// whitespace in them - the API stores a blank string, not null, for none.
export const hasLyrics = (song) => !!(song && typeof song.lyrics === "string" && song.lyrics.trim());
